// Session-scoped registry of originals that have already been fully loaded,
// so navigating back to an image can skip the blur/loader phase and render sharp.
const loaded = new Map() // fileId -> decoded HTMLImageElement (or true)
const pending = new Map() // fileId -> Promise<HTMLImageElement>

function fileIdOf(file) {
  return file && file.id != null ? file.id : null
}

export function isOriginalLoaded(file) {
  const id = fileIdOf(file)
  return id != null && loaded.has(id)
}

export function forgetOriginal(file) {
  const id = fileIdOf(file)
  if (id == null) return
  loaded.delete(id)
  pending.delete(id)
}

// Starts (or reuses) a hidden preload of the original file.
// Resolves with the decoded image; rejects when the request fails.
export function preloadOriginal(file) {
  const id = fileIdOf(file)
  if (id == null || !file.location) {
    return Promise.resolve(null)
  }
  if (loaded.has(id)) {
    return Promise.resolve(loaded.get(id))
  }
  if (!pending.has(id)) {
    const image = new Image()
    const promise = new Promise((resolve, reject) => {
      image.addEventListener('load', () => {
        loaded.set(id, image)
        pending.delete(id)
        resolve(image)
      })
      image.addEventListener('error', () => {
        pending.delete(id)
        reject(new Error(`Failed to preload image ${id}`))
      })
      image.src = file.location
    })
    pending.set(id, promise)
  }
  return pending.get(id)
}
